import React from 'react';
import RecentPosts from '../recentPosts/RecentPosts';
import ShortMenu from '../shortMenu/ShortMenu';
import refreshButton from '../../assets/img/feed-imgs/right/refresh.svg'
import FollowingPeople from '../followingPeople/FollowingPeople';
import './RightSiteBarMenu.css';

const RightSitebarMenu = () => {
    
    return (
        <> 
            {/*Short menu  */}
            <ShortMenu />
            {/* Recent Post Section */}
            <div className="row mb-4 ">
                <div className="col-12">
                    <div className="w-100 px-4 py-4" style={{borderRadius: "25px", backgroundColor:" #ffffff07"}}>
                        <div className="row mb-4">
                            <div className="col-12 d-flex justify-content-between align-items-center"><span className="happening">What's happening now</span><img src={refreshButton} alt="" /></div>
                        </div>
                        {/* Recent Post are here */}
                        <RecentPosts />
                    </div>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12">
                    <div className="w-100 px-4 py-3" style={{borderRadius: "25px",backgroundColor: "#ffffff07"}}>
                       {/* Following People are here */}
                        <FollowingPeople />
                    </div>
                </div>
            </div>
        </>
    );
};

export default RightSitebarMenu;